export const pattern8Data = [
  {
    id: 1,
    koreanChunks: [
      "만약 예산이",
      "(현재) 승인되면",
      "우리는",
      "시작할 수 있습니다.",
      "프로젝트를",
      "다음달에",
    ],
    englishChunks: [
      "If the budget",
      "is approved,",
      "we",
      "can start",
      "project",
      "next month",
    ],
    fullEnglish:
      "If the budget is approved, we can start the project next month.",
    explanation:
      "1형 가정법 - 현재 사실이나 미래에 일어날 수 있는 가능성 있는 상황을 표현합니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "만약 회사가",
      "(현재)확장하면",
      "그 회사의 사업을",
      "회사는 고용할 수도 있습니다",
      "더 많은 직원을",
    ],
    englishChunks: [
      "If the company",
      "expands",
      " its operations,",
      "it may hire",
      "more employees",
    ],
    fullEnglish:
      "If the company expands its operations, it may hire more employees.",
    explanation:
      "1형 가정법 - 현재 사실이나 미래에 일어날 수 있는 가능성 있는 상황을 표현합니다.",
  },
  {
    id: 3,
    koreanChunks: [
      "만약 당신이",
      " (현재) 구독하면 ",
      "우리의 뉴스레터를, ",
      "당신은 받을 것입니다",
      "주간 업데이트를",
    ],
    englishChunks: [
      "If you",
      "subscribe",
      "to our newsletter,",
      "you will receive",
      "weekly updates",
    ],
    fullEnglish:
      "If you subscribe to our newsletter, you will receive weekly updates.",
    explanation:
      "1형 가정법 - 현재 사실이나 미래에 일어날 수 있는 가능성 있는 상황을 표현합니다.",
  },
  {
    id: 4,
    koreanChunks: [
      "만약 날씨가",
      " (현재)좋아지면,",
      "야외 콘서트가",
      "진행될 것입니다",
      "예정대로",
    ],
    englishChunks: [
      "If the weather",
      " improves,",
      "the outdoor concert",
      "will take place",
      "as scheduled",
    ],
    fullEnglish:
      "If the weather improves, the outdoor concert will take place as scheduled.",
    explanation:
      "1형 가정법 - 현재 사실이나 미래에 일어날 수 있는 가능성 있는 상황을 표현합니다.",
  },
  {
    id: 5,
    koreanChunks: [
      "만약 당신이",
      " (과거에) 응답했다면 ",
      "더 일찍,",
      "우리는 마무리할 수 있었을 텐데요",
      "계약을",
    ],
    englishChunks: [
      "If you ",
      "responded ",
      "earlier,",
      "we would have been able to finalize",
      "the agreement",
    ],
    fullEnglish:
      "If you responded earlier, we would have been able to finalize the agreement.",
    explanation:
      "3형 가정법 - 과거의 사실과 반대되는 상황을 가정하여 표현합니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "만약 내가 (과거에) 당신이었다면",
      "나는 선택할 것입니다",
      "프리미엄 패키지를",
    ],
    englishChunks: ["If I were you", "I would choose", "the premium package"],
    fullEnglish: "If I were you, I would choose the premium package.",
    explanation:
      "2형 가정법 - 현재 사실과 반대되는 상황을 가정하여 표현합니다.",
  },
  {
    id: 7,
    koreanChunks: [
      "만약 지하철 시스템이",
      " (과거에)더 효율적이었다면,",
      "더 적은 사람들이",
      "운전할 것입니다",
      "직장에",
    ],
    englishChunks: [
      "If the subway system",
      "were more efficient,",
      "fewer people",
      "would drive",
      "to work",
    ],
    fullEnglish:
      "If the subway system were more efficient, fewer people would drive to work.",
    explanation:
      "2형 가정법 - 현재 사실과 반대되는 상황을 가정하여 표현합니다.",
  },
  {
    id: 8,
    koreanChunks: [
      "만약 항공사가",
      " (과거에) 알렸었다면 ",
      "승객들에게 ",
      "미리,",
      "지연이",

      "초래하지 않았을겁니다.",
      "그렇게 많은 불편을",
    ],
    englishChunks: [
      "If the airline",
      " had informed",
      " passengers",
      "in advance,",
      "the delay",

      "wouldn't have caused",
      "so much inconvenience",
    ],
    fullEnglish:
      "If the airline had informed passengers in advance, the delay wouldn't have caused so much inconvenience.",
    explanation:
      "3형 가정법 - 과거의 사실과 반대되는 상황을 가정하여 표현합니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "만약 당신이",
      " (과거에)참석했다면 ",
      "회의에,",
      "당신은 배울 수 있었을텐데",
      "유익한 통찰을",
    ],
    englishChunks: [
      "If you",
      "had attended",
      " the conference,",
      "you could have learned",
      "valuable insights",
    ],
    fullEnglish:
      "If you had attended the conference, you could have learned valuable insights.",
    explanation:
      "3형 가정법 - 과거의 사실과 반대되는 상황을 가정하여 표현합니다.",
  },
  {
    id: 10,
    koreanChunks: [
      "만약 그녀가",
      "(과거에) 인턴십을 했었더라면",
      "작년에,",
      "그녀는 일하고 있는 중일텐데",

      "대기업에서",
      "지금",
    ],
    englishChunks: [
      "If she",
      " had taken the internship ",
      "last year,",
      "she might be working",

      "for a top firm",
      "now",
    ],
    fullEnglish:
      "If she had taken the internship last year, she might be working for a top firm now.",
    explanation:
      "혼합 가정법 - 과거 사실의 반대 상황(3형)이 현재에 미치는 영향(2형)을 표현합니다.",
  },
  {
    id: 11,
    koreanChunks: [
      "과거에 회사가 시행했었더라면",
      "새로운 정책을 더 일찍, ",
      "그것은 보았었을 것입니다.",
      "향상된 결과를",
    ],
    englishChunks: [
      "Had the company implemented",
      " the new policy earlier,",
      "it would have seen",
      "improved results",
    ],
    fullEnglish:
      "Had the company implemented the new policy earlier, it would have seen improved results.",
    explanation:
      "3형 가정법 - 과거의 사실과 반대되는 상황을 가정하여 표현합니다. 'If + 주어 + had + p.p' 대신 'Had + 주어 + p.p' 형태로 도치되었습니다.",
  },
  {
    id: 12,
    koreanChunks: [
      "당신이 만약 (현재)있으시다면",
      "추가 질문이",
      "주저하지 마세요",
      "연락하는 것을",
      "저에게",
    ],
    englishChunks: [
      "Should you have",
      "any further questions",
      "please do not hesitate",
      "to contact",
      "me",
    ],
    fullEnglish:
      "Should you have any further questions, please do not hesitate to contact me.",
    explanation:
      "조건문의 도치 표현 - 'If you should have' 대신 'Should you have'를 사용하여 더 격식 있는 표현이 되었습니다. 주로 비즈니스 이메일에서 사용됩니다.",
  },
  {
    id: 13,
    koreanChunks: [
      "과거에 우리가 받았었다면",
      " 당신의 결재를 더 일찍,",
      "우리는 배송을 했을 것입니다",
      "귀하의 주문을",
      "지난주에",
    ],
    englishChunks: [
      "Had we received",
      " your payment earlier,",
      "we would have shipped",
      "your order",
      "last week",
    ],
    fullEnglish:
      "Had we received your payment earlier, we would have shipped your order last week.",
    explanation:
      "3형 가정법 - 과거의 사실과 반대되는 상황을 가정하여 표현합니다. 'If we had received' 대신 'Had we received' 형태로 도치되었습니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "과거에 제가 알았더라면 ",
      "회의에 대해,",
      "나는 준비했었을 것입니다",
      "필요한 문서를",
    ],
    englishChunks: [
      "Had I known",
      " about the meeting,",
      "I would have prepared",
      "the necessary documents",
    ],
    fullEnglish:
      "Had I known about the meeting, I would have prepared the necessary documents.",
    explanation:
      "3형 가정법 - 과거의 사실과 반대되는 상황을 가정하여 표현합니다. 'If I had known' 대신 'Had I known' 형태로 도치되었습니다.",
  },
  {
    id: 15,
    koreanChunks: [
      "과거에 당신이 알려주었다면 우리에게",
      " 그 문제를 더 일찍,",
      "우리는 해결할 수 있었을 것입니다 그 문제를 ",
      "신속하게",
    ],
    englishChunks: [
      "Had you informed us ",
      "about the issue sooner,",
      "we could have resolved it",
      "promptly",
    ],
    fullEnglish:
      "Had you informed us about the issue sooner, we could have resolved it promptly.",
    explanation:
      "3형 가정법 - 과거의 사실과 반대되는 상황을 가정하여 표현합니다. 'If you had informed' 대신 'Had you informed' 형태로 도치되었습니다.",
  },
  {
    id: 16,
    koreanChunks: [
      "과거에 회사가 투자했었더라면 ",
      "재생 에너지에 더 일찍,",
      "줄였을것이다",
      "운영 비용을",
    ],
    englishChunks: [
      "Had the company invested ",
      "in renewable energy earlier,",
      "it would have reduced",
      "operational costs",
    ],
    fullEnglish:
      "Had the company invested in renewable energy earlier, it would have reduced operational costs.",
    explanation:
      "3형 가정법 - 과거의 사실과 반대되는 상황을 가정하여 표현합니다. 'If the company had invested' 대신 'Had the company invested' 형태로 도치되었습니다.",
  },
  {
    id: 17,
    koreanChunks: [
      "당신이 (현재)결정하셔야 한다면",
      "수락하기로 우리의 제안을,",
      "서명하시고",
      "보내주시기 바랍니다",
      "첨부된 계약서를",
    ],
    englishChunks: [
      "Should you decide",
      "to accept our offer,",
      "please sign",
      "and return",
      "the attached contract",
    ],
    fullEnglish:
      "Should you decide to accept our offer, please sign and return the attached contract.",
    explanation:
      "조건문의 도치 표현 - 'If you should decide' 대신 'Should you decide'를 사용하여 더 격식 있는 표현이 되었습니다. 주로 비즈니스 문서나 공식적인 이메일에서 사용됩니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "당신이 만약 (현재)있으시다면",
      "어떤 추가 질문이,",
      "언제든 연락 주시기 바랍니다",
    ],
    englishChunks: [
      "Should you have",
      "any further questions,",
      "feel free to reach out",
    ],
    fullEnglish:
      "Should you have any further questions, feel free to reach out.",
    explanation:
      "조건문의 도치 표현 - 'If you should have' 대신 'Should you have'를 사용하여 더 격식 있는 표현이 되었습니다. 비즈니스 이메일을 마무리할 때 자주 사용되는 표현입니다.",
  },
  {
    id: 19,
    koreanChunks: [
      "나는 바란다",
      "내가 (과거에) 더 많은 시간을 가졌기를",

      "마치기 위해 ",
      "이 프로젝트를",
    ],
    englishChunks: ["I wish", "I had more time", "to complete", "this project"],
    fullEnglish: "I wish I had more time to complete this project.",
    explanation:
      "가정법 wish 구문 - 'wish + 과거시제'를 사용하여 현재 상황과 반대되는 희망사항을 표현합니다.",
  },
  {
    id: 20,
    koreanChunks: [
      "만약 그녀가 (과거에) 회사를 그만 뒀다면",
      "그것은 (현재) 큰 손실이 될 것이다",
      "회사에",
    ],
    englishChunks: [
      "If she were to quit her job",
      "it would be a big loss",
      "for the company",
    ],
    fullEnglish:
      "If she were to quit her job, it would be a big loss for the company.",
    explanation:
      "2형 가정법 - 'were to' 구문을 사용하여 미래의 가능성이 있는 상황을 가정합니다.",
  },
  {
    id: 21,
    koreanChunks: [
      "만약 그가 (현재) 전화해야 한다면",
      "전해주세요 그에게",
      "내가 회의 중이라고",
    ],
    englishChunks: ["If he should call,", "tell him", "I'm in a meeting"],
    fullEnglish: "If he should call, tell him I'm in a meeting.",
    explanation:
      "should를 사용한 가정법 - 'If + 주어 + should + 동사원형'을 사용하여 발생 가능성이 낮거나 불확실한 상황을 가정합니다.",
  },
  {
    id: 22,
    koreanChunks: [
      "만약 그들이 (과거에) 연기했다면",
      " 그 프로젝트를,",
      "그것이 영향을 줄 수 있다",
      "전체 일정에",
    ],
    englishChunks: [
      "If they were to delay",
      "the project",
      "it could affect",
      "the entire schedule",
    ],
    fullEnglish:
      "If they were to delay the project, it could affect the entire schedule.",
    explanation:
      "2형 가정법 - 'were to' 구문을 사용하여 미래의 가능성이 있는 상황을 가정합니다.",
  },
  {
    id: 23,
    koreanChunks: ["과거에 내가 너라면,", "나는 받을 겁니다", "그 일자리를"],
    englishChunks: ["Were I you", "I would take", "the job"],
    fullEnglish: "Were I you, I would take the job.",
    explanation:
      "2형 가정법의 도치 표현 - 'If I were you' 대신 'Were I you'를 사용하여 더 격식 있게 표현합니다.",
  },
  {
    id: 24,
    koreanChunks: [
      "전혀 없다",
      "우리가 경험했던 적이",
      "이렇게 급격한 시장 변화를",
    ],
    englishChunks: [
      "Never have",
      "we experienced",
      "such a rapid market change",
    ],
    fullEnglish: "Never have we experienced such a rapid market change.",
    explanation:
      "부정어(Never)로 시작하는 도치 구문입니다. 강조를 위해 일반적인 어순 대신 부정어를 문장 앞으로 보내고 조동사와 주어를 도치시켰습니다.",
  },
  {
    id: 25,
    koreanChunks: ["거의 안그런다", "회사가 제공하는게 할인을", "성수기에"],
    englishChunks: [
      "Rarely does",
      "the company offer discounts",
      "during peak season",
    ],
    fullEnglish: "Rarely does the company offer discounts during peak season.",
    explanation:
      "부정어(Rarely)로 시작하는 도치 구문입니다. 강조를 위해 일반적인 어순 대신 부정어를 문장 앞으로 보내고 조동사(does)와 주어를 도치시켰습니다.",
  },
  {
    id: 26,
    koreanChunks: [
      "모든 승인이 (현재)얻어저야만",
      "할 수 있어요",
      "우리가 진행하는 것 프로젝트를",
    ],
    englishChunks: [
      "Not until all approvals are obtained,",
      "can",
      "we proceed with the project",
    ],
    fullEnglish:
      "Not until all approvals are obtained can we proceed with the project.",
    explanation:
      "부정어구(Not until)로 시작하는 도치 구문입니다. 'Not until' 다음에 조동사(can)와 주어(we)가 도치되어 강조를 나타냅니다.",
  },
  {
    id: 27,
    koreanChunks: ["이제 막 했다", "회의가 시작을", "화재 경보가 울렸을 떄"],
    englishChunks: [
      "Hardly had",
      "the meeting started",
      "when the fire alarm went off",
    ],
    fullEnglish: "Hardly had the meeting started when the fire alarm went off.",
    explanation:
      "부정어(Hardly)로 시작하는 도치 구문입니다. 'Hardly' 다음에 조동사(had)와 주어(the meeting)가 도치되어 시간의 즉시성을 강조합니다.",
  },
  {
    id: 28,
    koreanChunks: [
      "전혀 없다",
      "내가 본적이",
      "이렇게 급격한 증가를",
      "매출에서",
    ],
    englishChunks: [
      "Never have",
      "I seen",
      "such a rapid increase",
      " in sales",
    ],
    fullEnglish: "Never have I seen such a rapid increase in sales.",
    explanation:
      "부정어(Never)로 시작하는 도치 구문입니다. 강조를 위해 일반적인 어순 대신 부정어를 문장 앞으로 보내고 조동사(have)와 주어(I)를 도치시켰습니다.",
  },
  {
    id: 29,
    koreanChunks: [
      "좀처럼 안그런다",
      "직원들이 갖는 것",
      "만날 기회를",
      "이사를",
      "직접",
    ],
    englishChunks: [
      "Seldom do ",
      "employees get",
      "a chance to meet",
      "the director",
      "in person",
    ],
    fullEnglish:
      "Seldom do employees get a chance to meet the director in person.",
    explanation:
      "부정어(Seldom)로 시작하는 도치 구문입니다. 강조를 위해 일반적인 어순 대신 부정어를 문장 앞으로 보내고 조동사(do)와 주어(employees)를 도치시켰습니다.",
  },
  {
    id: 30,
    koreanChunks: [
      "우리가 (과거에)서명하자마자 계약서에",
      "그 다음에 그들이",
      "(과거에)발표했습니다",
      "가격 인상을",
    ],
    englishChunks: [
      "No sooner had we signed the contract",
      "than they",
      "announced",
      "a price increase",
    ],
    fullEnglish:
      "No sooner had we signed the contract than they announced a price increase.",
    explanation:
      "부정어구(No sooner)로 시작하는 도치 구문입니다. 'No sooner' 다음에 조동사(had)와 주어(we)가 도치되어 시간의 즉시성을 강조합니다.",
  },
  {
    id: 31,
    koreanChunks: [
      "모든 문서가 서명이 되어야",
      "할 수 있어요",
      "우리가 진행하는것 프로젝트를",
    ],
    englishChunks: [
      "Not until all the documents are signed",
      "can",
      "we proceed with the project",
    ],
    fullEnglish:
      "Not until all the documents are signed can we proceed with the project.",
    explanation:
      "부정어구(Not until)로 시작하는 도치 구문입니다. 'Not until' 다음에 조동사(can)와 주어(we)가 도치되어 강조를 나타냅니다.",
  },
  {
    id: 32,
    koreanChunks: ["결제가 완료되어야만", "될거에요", "주문이 처리가"],
    englishChunks: [
      "Not until the payment is completed",
      "will",
      "the order be processed",
    ],
    fullEnglish:
      "Not until the payment is completed will the order be processed.",
    explanation:
      "부정어구(Not until)로 시작하는 도치 구문입니다. 'Not until' 다음에 조동사(will)와 주어(the order)가 도치되어 강조를 나타냅니다.",
  },
  {
    id: 33,
    koreanChunks: [
      "오직 모든 조건이 충족될 때에만",
      "가능합니다",
      "계약이 완료되어지는것이",
    ],
    englishChunks: [
      "Only when all the conditions are met",
      "can",
      "the contract be finalized",
    ],
    fullEnglish:
      "Only when all the conditions are met can the contract be finalized.",
    explanation:
      "Only로 시작하는 도치 구문입니다. 'Only when' 다음에 조동사(can)와 주어(the contract)가 도치되어 강조를 나타냅니다.",
  },
  {
    id: 34,
    koreanChunks: [
      "오직 계약서가 서명되었을 때에만",
      "될 것입니다",
      "합의가 효력이 발휘되는 것",
    ],
    englishChunks: [
      "Only when the contract is signed",
      "will",
      "the agreement become effective",
    ],
    fullEnglish:
      "Only when the contract is signed will the agreement become effective.",
    explanation:
      "Only로 시작하는 도치 구문입니다. 'Only when' 다음에 조동사(will)와 주어(the agreement)가 도치되어 강조를 나타냅니다.",
  },
  {
    id: 35,
    koreanChunks: [
      "오직 효과적인 의사소통을 통해서만",
      "-것입니다",
      "팀이 성공할",
    ],
    englishChunks: [
      "Only through effective communication",
      "will",
      "the team succeed",
    ],
    fullEnglish: "Only through effective communication will the team succeed.",
    explanation:
      "Only로 시작하는 도치 구문입니다. 'Only through' 다음에 조동사(will)와 주어(the team)가 도치되어 강조를 나타냅니다.",
  },
  {
    id: 36,
    koreanChunks: [
      "오직 조건이 유리한 경우에만",
      "해야합니다",
      "우리가 진행하는것 합의를",
    ],
    englishChunks: [
      "Only if the terms are favorable",
      "should",
      "we proceed with the agreement",
    ],
    fullEnglish:
      "Only if the terms are favorable should we proceed with the agreement.",
    explanation:
      "Only로 시작하는 도치 구문입니다. 'Only if' 다음에 조동사(should)와 주어(we)가 도치되어 강조를 나타냅니다.",
  },

  {
    id: 37,
    koreanChunks: [
      "그 회사는",
      "더 이상 (현재)받지 않는 중입니다",
      "채용 지원서를",
    ],
    englishChunks: [
      "The company",
      "is no longer accepting",
      "job applications",
    ],
    fullEnglish: "The company is no longer accepting job applications.",
    explanation:
      "현재진행형과 'no longer'를 사용하여 더 이상 지속되지 않는 상황을 표현합니다.",
  },
  {
    id: 38,
    koreanChunks: ["수정된 정책이", "더 나을 것이 없다", "원래 정책보다"],
    englishChunks: [
      "The revised policy",
      "is no better",
      "than the original one",
    ],
    fullEnglish: "The revised policy is no better than the original one.",
    explanation:
      "비교 구문에서 'no better than'을 사용하여 '~보다 더 나을 것이 없다'는 의미를 표현합니다.",
  },
  {
    id: 39,
    koreanChunks: ["그는", "더 이상 책임이 없다", "고객 불만을 처리할"],
    englishChunks: [
      "He",
      "is no longer responsible",
      "for handling customer complaints",
    ],
    fullEnglish:
      "He is no longer responsible for handling customer complaints.",
    explanation:
      "'no longer'를 사용하여 더 이상 지속되지 않는 책임이나 의무를 표현합니다.",
  },
  {
    id: 40,
    koreanChunks: ["아무도 통보받지 못했다", "회의 취소에 대해", "사전에"],
    englishChunks: [
      "Nobody was informed",
      "about the meeting cancellation",
      "in advance",
    ],
    fullEnglish:
      "Nobody was informed about the meeting cancellation in advance.",
    explanation:
      "'Nobody'를 주어로 사용한 부정문으로, 수동태와 함께 '아무도 ~하지 않았다'는 의미를 표현합니다.",
  },
  {
    id: 41,
    koreanChunks: ["어느 후보도 충족하지 못했다", "최소 자격 요건을"],
    englishChunks: [
      "Neither of the candidates met",
      "the minimum qualifications",
    ],
    fullEnglish: "Neither of the candidates met the minimum qualifications.",
    explanation:
      "'Neither of ~'를 사용하여 '어느 ~도 ~하지 않았다'라는 의미를 표현합니다.",
  },
];
